import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _205aaf7c = () => interopDefault(import('../../../entries/main/pages/account.vue' /* webpackChunkName: "entries/main/pages/account" */))
const _a04d4086 = () => interopDefault(import('../../../entries/main/pages/amoe.vue' /* webpackChunkName: "entries/main/pages/amoe" */))
const _8820dfe6 = () => interopDefault(import('../../../entries/main/pages/ar-redirect.vue' /* webpackChunkName: "entries/main/pages/ar-redirect" */))
const _e34ad9aa = () => interopDefault(import('../../../entries/main/pages/faq.vue' /* webpackChunkName: "entries/main/pages/faq" */))
const _0c6b571a = () => interopDefault(import('../../../entries/main/pages/forgot-password.vue' /* webpackChunkName: "entries/main/pages/forgot-password" */))
const _719d3039 = () => interopDefault(import('../../../entries/main/pages/fraud.vue' /* webpackChunkName: "entries/main/pages/fraud" */))
const _45e72a84 = () => interopDefault(import('../../../entries/main/pages/login.vue' /* webpackChunkName: "entries/main/pages/login" */))
const _cc5f69c8 = () => interopDefault(import('../../../entries/main/pages/prizes.vue' /* webpackChunkName: "entries/main/pages/prizes" */))
const _664acd5e = () => interopDefault(import('../../../entries/main/pages/register.vue' /* webpackChunkName: "entries/main/pages/register" */))
const _25f01258 = () => interopDefault(import('../../../entries/main/pages/reset-password.vue' /* webpackChunkName: "entries/main/pages/reset-password" */))
const _703f6568 = () => interopDefault(import('../../../entries/main/pages/rules.vue' /* webpackChunkName: "entries/main/pages/rules" */))
const _55699c90 = () => interopDefault(import('../../../entries/main/pages/scan.vue' /* webpackChunkName: "entries/main/pages/scan" */))
const _719b1066 = () => interopDefault(import('../../../entries/main/pages/unsubscribe.vue' /* webpackChunkName: "entries/main/pages/unsubscribe" */))
const _1364c7a7 = () => interopDefault(import('../../../entries/main/pages/index.vue' /* webpackChunkName: "entries/main/pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _205aaf7c,
    name: "account"
  }, {
    path: "/amoe",
    component: _a04d4086,
    name: "amoe"
  }, {
    path: "/ar-redirect",
    component: _8820dfe6,
    name: "ar-redirect"
  }, {
    path: "/faq",
    component: _e34ad9aa,
    name: "faq"
  }, {
    path: "/forgot-password",
    component: _0c6b571a,
    name: "forgot-password"
  }, {
    path: "/fraud",
    component: _719d3039,
    name: "fraud"
  }, {
    path: "/login",
    component: _45e72a84,
    name: "login"
  }, {
    path: "/prizes",
    component: _cc5f69c8,
    name: "prizes"
  }, {
    path: "/register",
    component: _664acd5e,
    name: "register"
  }, {
    path: "/reset-password",
    component: _25f01258,
    name: "reset-password"
  }, {
    path: "/rules",
    component: _703f6568,
    name: "rules"
  }, {
    path: "/scan",
    component: _55699c90,
    name: "scan"
  }, {
    path: "/unsubscribe",
    component: _719b1066,
    name: "unsubscribe"
  }, {
    path: "/",
    component: _1364c7a7,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
